export type WpRequirement = [number, number];

const phpToWpRequirementMap: Record<string, WpRequirement> = {
  '8': [6, 0],
  '8.1': [6, 0],
  '8.2': [6, 2],
  '8.3': [6, 5],
};

export function parseWpVersion(versionString: string): { major: number; minor: number } {
  const parts = (versionString || '').split('.');
  const major = parseInt(parts[0]) || 0;
  const minor = parseInt(parts[1]) || 0;
  return { major, minor };
}

export function getRequiredWpForPhp(phpVersion: string): WpRequirement | null {
  return phpToWpRequirementMap[phpVersion] ?? null;
}

export function isWpLowerThanRequirement(wpMajor: number, wpMinor: number, requirement: WpRequirement): boolean {
  const [requiredMajor, requiredMinor] = requirement;
  return wpMajor < requiredMajor || (wpMajor === requiredMajor && wpMinor < requiredMinor);
}
